// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import moment from 'moment';
import { orderStatusCode } from './constants';

export const DUE_SOON_DAYS = 7;

export type DeliveryState = 'overdue' | 'dueSoon' | 'scheduled' | 'delivered' | 'none';

export interface IDeliverySchedule {
  state: DeliveryState;
  // UTC, because server dates are UTC and local-time parsing can shift the day.
  date: moment.Moment | null;
}

// One reading of "when is this due and how urgently" for everything that shows delivery
// dates - the pin overview card and the portfolio summary rail must never disagree.
export const resolveDeliverySchedule = (project: {
  orderStatus?: number;
  deliveryDate?: string;
  deliveryEstimate?: string;
}): IDeliverySchedule => {
  const raw = project.deliveryDate || project.deliveryEstimate;
  const date = raw ? moment.utc(raw) : null;

  if (project.orderStatus === orderStatusCode.done) return { state: 'delivered', date };
  // A canceled order has no delivery coming - a past date on it is history, not urgency.
  if (project.orderStatus === orderStatusCode.canceled) return { state: 'none', date: null };
  if (!date) return { state: 'none', date: null };

  // isBefore, not day-diff: diff truncates toward zero, which would misread the whole first
  // day past due as merely due soon.
  if (date.isBefore(moment.utc())) return { state: 'overdue', date };
  if (date.diff(moment.utc(), 'days') <= DUE_SOON_DAYS) return { state: 'dueSoon', date };
  return { state: 'scheduled', date };
};
